define('viewModels/NavMenu',[
    'lib/knockout',
    'lib/lodash4',
    'services/routeService',
    'viewModels/ViewModel'
], function (ko, _, routeService, ViewModel) {
    'use strict';

    var listMenuItemsByHashLength = function(navItems, sortedAccumulator) {
        var sortedItems = sortedAccumulator || [];
        _.forEach(navItems, function (navItem) {
            if (navItem.sectionTitle) {
                listMenuItemsByHashLength(navItem.menuItems, sortedItems);
            } else {
                var insertIndex = _.sortedIndexBy(sortedItems, navItem, function (item) {
                    var hashValue = ko.unwrap(item.hash);
                    return hashValue.length;
                });
                sortedItems.splice(insertIndex, 0, navItem);
            }
        });
        return sortedItems;
    };

    /**
     * A ViewModel to help with the management of displaying a navigation menu.
     *
     * @param {array} navItems - an array of objects that must adhere to following
     * structure:
     *
     *     {
     *       hash: "#/route"     // A string representing the route that the browser
     *                           // should be set to when this item is selected
     *
     *       label: "messageKey" // A message key whose value is the text that will
     *                           // display for the nav button
     *
     *       cssClass: "string"    // (optional) A string with a space-separated list of css class names to apply.
     *     }
     */
    var NavMenu = ViewModel.extend(function (navItems) {
        var self = this;

        self.navItems = ko.observableArray();

        // Sets the active item to the longest one matching the hash tag.
        // NOTE: A regular expression can be used.
        self.setActive = function (hash) {
            if (hash && hash.length > 0) {
                // Given items of '#test123' and "#test123/456", if the route's hash is
                // '#test123/456', they will both match, but the longer one should be activated.
                var sortedItems = listMenuItemsByHashLength(self.navItems());
                var foundActive = false;
                // Find the active item, starting with the longest hash. Set all
                // others to inactive.
                _.forEachRight(sortedItems, function (item) {
                    var pattern = new RegExp('^' + item.hash);
                    if (!foundActive && pattern.test(hash)) {
                        item.active(true);
                        foundActive = true;
                    }
                    else {
                        item.active(false);
                    }
                });
            }
        };

        self.addNavItem = function (navItem) {
            if (navItem.sectionTitle) {
                _.forEach(navItem.menuItems, function (menuItem) {
                    menuItem.active = ko.observable(false);
                    menuItem.computedCssClass = self.computed(function () {
                        var cssClass = ko.unwrap(menuItem.cssClass) || '';
                        if (menuItem.active()) {
                            cssClass = cssClass ? cssClass + ' ' + 'active' : 'active';
                        }
                        return cssClass;
                    });
                    //if an href option was provided separate from hash, use it, otherwise use the hash option
                    menuItem.href = menuItem.href || menuItem.hash;
                });
            } else {
                navItem.active = ko.observable(false);
                navItem.computedCssClass = self.computed(function () {
                    var cssClass = ko.unwrap(navItem.cssClass) || '';
                    if (navItem.active()) {
                        cssClass = cssClass ? cssClass + ' ' + 'active' : 'active';
                    }
                    return cssClass;
                });
                //if an href option was provided separate from hash, use it, otherwise use the hash option
                navItem.href = navItem.href || navItem.hash;
            }
            self.navItems.push(navItem);
        };

        self.containsNavItem = function (navItem) {
            return !!_.find(self.navItems(), { href: navItem.hash } );
        };

        self.removeNavItem = function (navItem) {
            var matchedNavItem = _.find(self.navItems(), { href: navItem.hash } );
            if(matchedNavItem) {
                self.navItems.remove(matchedNavItem);
            }
        };

        // Initialize from constructor parameter
        _.forEach(navItems, function (navItem) {
            self.addNavItem(navItem);
        });

        // Set inital state.
        self.setActive(window.location.hash);

        // Update the active item state whenever the route changes.
        self.computed(function () {
            self.setActive(routeService.route());
        });
    });

    return NavMenu;
});

